import { render, staticRenderFns } from "./properties.vue?vue&type=template&id=02d76db0&scoped=true&"
import script from "./properties.ts?vue&type=script&lang=ts&"
export * from "./properties.ts?vue&type=script&lang=ts&"
import style0 from "./properties.vue?vue&type=style&index=0&id=02d76db0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.1_cache-loader@4.1.0_webpack@4.44.2__css-loader@3.5.2_webpack@4.44.2__lodash@_woylw74pnr2dauffvwh757gxea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d76db0",
  null
  
)

export default component.exports